
































































import Vue from 'vue'
import Component from 'vue-class-component'
import CvView from '@app/componentlib/src/views/cvtool-pages/CvView.vue'
import PageContent from '@app/componentlib/src/views/components/PageContent.vue'
import CardList from '@app/componentlib/src/views/cvtool-pages/CardList.vue'
import { ProfileModule } from '@app/componentlib/src/store/modules/profile'
import { CV, HelpTextProfile } from '@app/componentlib/common/types/CVTypes'
import { Option } from '@app/componentlib/common/types/BootstrapTypes'
import { CvModule } from '@app/componentlib/src/store/modules/cvdata'
import { AppModule, PortalSettings } from '@app/componentlib/src/store/modules/app'
import { LanguageNames } from '@app/componentlib/common/types'
import { ga } from '@app/componentlib/src/application/analytics'

@Component<CvPage>({
  components: {
    CvView,
    PageContent,
    CardList
  },
  props: {
    title: String,
    description: String,
    documents: Array,
    userCountry: String,
    links: Array,
    helptextProfiles: Array,
    profileLink: String,
    profileLinkText: String,
    competencesLink: String,
    linkToDocuments: String,
    documentsLinkName: String,
    url: String,
    translations: Object,
    tags: Array,
    cvLinkText: String,
    cvLinkUrl: String,
    applicationLinkText: String,
    applicationLinkUrl: String,
    languageNames: String,
    siteLanguage: String
  }
})

export default class CvPage extends Vue {
  /**
   * Props variables
   */
  title: string | undefined
  description: string | undefined
  documents: CV[] | null | undefined
  userCountry: string | undefined
  links: [] | undefined
  helptextProfiles: HelpTextProfile[] | undefined
  profileLink: string | undefined
  profileLinkText: string | undefined
  competencesLink: string | undefined
  linkToDocuments: string | undefined
  documentsLinkName: string | undefined
  url: string | undefined
  translations: object | undefined
  tags: any[] | undefined
  applicationLinkText: string | undefined
  applicationLinkUrl: string | undefined
  languageNames: LanguageNames | undefined
  siteLanguage: string | undefined

  /**
   * Component state variables
   */
  cvHash = ['#1', '#2', '#3', '#4']
  selectedLang: string | null = null
  search: string = ''
  history: string = this.cvHash.includes(location.hash) ? location.hash : ''
  selectedTag: string | null = null
  savedScrollPosition: number = 0

  /**
   * Lifecycle
   */
  async mounted() {
    if(this.documents !== null && this.documents !== undefined) CvModule.setAllCvs(this.documents)
    if(this.translations !== undefined) await AppModule.setTranslations(this.translations)
    await AppModule.init()
    const portalSettings: PortalSettings = { profileLink: this.profileLink}
    await AppModule.changePortalSettings(portalSettings)
    await CvModule.init()
    if(this.helptextProfiles !== undefined) CvModule.setHelpTextProfiles(this.helptextProfiles)
    //Check what page we are on.
    //If above 0 we want to find the selected cv
    let currentPage = localStorage.getItem('cvSectionPath')
    if(this.history === '#1') {
      // clear selection if user browser back or refresh
      this.clearSelection()
    } else if (currentPage === null) {
      localStorage.setItem('cvSectionPath', '1')
    } else if (currentPage === null || currentPage === '1') {
      location.hash = '1'
    } else if (currentPage > '1'){
      console.log('currentPage is more than 1')
      //If currentPage above 1 we find the previously selected cv
      let cvId = CvModule.cvId
      if(CvModule.allCvs !== undefined && cvId !== undefined) {
        let currentCv: CV | undefined = CvModule.allCvs.find((i: CV) => i.mediaId === cvId?.mediaId && i.language === cvId?.lang)
        if(currentCv !== undefined) CvModule.setSelectedCv(currentCv)
      } else {
        //This shouldn't happen.
        console.warn('No documents, reset CvPage')
        this.clearSelection()
      }
    }

    // On mount we set the selected language to the siteLanguage
    this.selectedLang = this.siteLanguage ? this.siteLanguage : null

    //Init profile module
    ProfileModule.init()

    window.addEventListener(
      'popstate', this.handleHistoryChange
    )
  }

  beforeDestroy () {
    // Cleanup code
    console.log('Detach event handlers on CvPage')
    window.removeEventListener(
      'popstate', this.handleHistoryChange
    )
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get lang (): Option[] {
    let lang: Option[] = []
    const langNames = this.languageNames
    if(langNames !== undefined) {

      Object.keys(langNames).forEach(k => {
        lang.push({
          value: k,
          text: langNames[k]
        })
      })
    }
    return lang
  }

  get filteredItems (): CV[] | undefined {
    //Filter Documents with our set filters
    if(CvModule.allCvs !== undefined) {
      let list = CvModule.allCvs.filter((item: CV) => {
          if(this.selectedLang === null) return item
          if(item.language !== null) return item.language === this.selectedLang
      })
      if(list !== undefined) {
        list = list.filter((item: CV) => {
          if(item !== undefined && this.search !== undefined) {
            return item.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          }
        }).filter(i => i.previewImage !== null && i.previewImage !== '')
        //Filter layout tags:
        let cvWithTag: Option | undefined = undefined
        if(this.layoutTags !== undefined) {
          // Find the selectedTag to filter by
          cvWithTag = this.layoutTags.find((tag: any) => tag.value === this.selectedTag)
        }
        // Filter our `list` with the CV's with the selected tag - dont do it if the filtertag is undefined or the value is null (This is the default value(:null))
        if(cvWithTag !== undefined && cvWithTag.value !== null) list = list.filter(e => cvWithTag?.list?.includes(e.templateId))
        return list
      }
      return undefined
    }
    return undefined
  }
  get selectedCV (): CV | undefined {
    return CvModule.selectedCv
  }

  get layoutTags (): Option[] | undefined {
    // Get all tags for filtering
    if(this.tags !== undefined) {
      let layoutTags: any[] = [{
        value: null,
        text: this.t.general_Show_All
      }]
      if(this.tags.length > 0) {
        const x = this.tags.find((t: any) => t.type === "Layout").tags
        x.forEach((e: any) => {
          layoutTags.push({
            value: e.id,
            text: e.name,
            list: e.CVs
          })
        })
      }
      return layoutTags
    } else {
      return undefined
    }
  }

    /**
   * Methods
   */
  selectCV (cv:CV) {
    if(cv.template === true) {
      //If template, use template setup flow
      localStorage.setItem('cvSectionPath', '2')
    } else {
      //Send directly to download
      localStorage.setItem('cvSectionPath', '4')
    }
    if(cv !== undefined) {
      CvModule.setCvId({ mediaId: cv.mediaId, lang: cv.language })
      CvModule.setSelectedCv(cv)
      this.savedScrollPosition = window.pageYOffset
    }
  }

  clearSelection () {
    //Clear all the picked choices and make sure we are ready to start a new setup with a new CV.
    CvModule.deleteSelectedCv()
    location.hash = '1'
    localStorage.setItem('cvSectionPath', '1')
    CvModule.clearCVSelections()

    this.$nextTick(() => {
      window.focus()
      window.scrollTo(0, this.savedScrollPosition)
      if (window.pageYOffset !== this.savedScrollPosition) {
        setTimeout(() => {
          window.scrollTo(0, this.savedScrollPosition)
        }, 50)
      }
    })
  }

  handleHistoryChange() {
    this.history = location.hash
    if(this.history === '#1') {
      // clear selection if user browser back or refresh
      this.clearSelection()
    } else {
      if(this.selectedCV?.template === true) {
        if(this.cvHash.includes(this.history)) {
          localStorage.setItem('cvSectionPath', this.history.substring(1))
        }
      }
    }
  }

  selectTag() {
    ga.event({
      action: 'User filtered by tag',
      category: 'CV Tool',
      label: this.selectedTag
    })
  }
}
